import Ajv, { Schema } from "ajv"
import ajvErrors from "ajv-errors"
import addFormats from "ajv-formats"

const ajv = new Ajv({ allErrors: true })
ajvErrors(ajv)
addFormats(ajv)

type ReturnType = [boolean, Record<string, string[]> | null]

export function validateData<T>(data: T, schema: Schema): ReturnType {
  const validate = ajv.compile(schema)
  const valid = validate(data)

  if (!valid) {
    const errorObject: Record<string, string[]> = {}

    for (const error of validate.errors || []) {
      const key = error.instancePath.slice(1)
      const keyErrors = errorObject[key] || []
      keyErrors.push(error.message as string)
      errorObject[key] = keyErrors
    }
    return [false, errorObject]
  }

  return [true, null]
}
